export default __webpack_public_path__ + "static/media/Bird1.50350c6c.png";